export default __webpack_public_path__ + "static/media/polygon.97ff139c.svg";